import React, { useEffect, useRef, useState } from "react";
import { Storage } from "@aws-amplify/storage";
import { alpha, Box, Button, ButtonGroup, Grid, IconButton, InputAdornment, Paper, Stack, Switch, TextField, Typography } from "@mui/material";
import useMouse from "@react-hook/mouse-position";
import FeatherIcon from "feather-icons-react";
import ReactPlayer from "react-player";
import WaveformData from "waveform-data";
import LegendItemGroup from "../../components/legend-item-group/index.jsx";
import CustomSvgIcons from "../../components/svg-icons/index.jsx";
import { useThemeMode } from "../../components/theme/index.jsx";
import { colours as constColours, CustomTooltip, toggleButtonStyle } from "../../consts.js";
import { THEME_MODES } from "../../helpers/constant.js";
import Utils from "../../utils";
import MessageRow from "./message-row.jsx";
import useWindowSize from "./window-resize.jsx";
// import { getAlertsAPI } from "../../services/alerts.js";

function ConversationTranscript({ conversationId }) {
    const size = useWindowSize();

    const [conversation, setConversation] = useState({});
    const [autoscroll, setAutoscroll] = useState(false);
    const [conversationFile, setConversationFile] = useState("");
    const [trackerSet, setTrackerSet] = useState([]);
    const [topicSet, setTopicSet] = useState([]);
    const [agent, setAgent] = useState("Speaker 2");
    const [tsfilter, setTsFilter] = useState("Full");
    const { colours, themeMode } = useThemeMode();
    const scrollContainer = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [alerts, setAlerts] = React.useState([]);

    async function getConversationData() {
        const conversation = await Utils.genericGet("getConversation", conversationId);

        conversation.data.getConversation.analytics = JSON.parse(
            conversation.data.getConversation.analytics
        );
        conversation.data.getConversation.questions = JSON.parse(
            conversation.data.getConversation.questions
        );
        conversation.data.getConversation.summary = JSON.parse(
            conversation.data.getConversation.summary
        );
        conversation.data.getConversation.topics = JSON.parse(
            conversation.data.getConversation.topics
        );
        conversation.data.getConversation.trackersdetected = JSON.parse(
            conversation.data.getConversation.trackersdetected
        ) || [];

        conversation.data.getConversation.trackersdetected.forEach((t) => {
            if (!t.matches) {
                t.matches = [];
            }
        })

        conversation.data.getConversation.transcript = JSON.parse(
            conversation.data.getConversation.transcript
        );
        setAgent(conversation.data.getConversation.agenttag);
        // console.log({ conversation });
        let newtrackerset = [];
        conversation.data.getConversation.trackersdetected.forEach((z) => {
            z.matches.forEach((a) => {
                a.messageRefs.forEach((b) => {
                    newtrackerset.push({
                        name: z.name,
                        id: b.id,
                        alert: alerts.find((q) => q.name === z.name) ? true : false,
                    });
                });
            });
        });

        setTrackerSet(newtrackerset);
        let newtopicset = [];
        try {
            conversation.data.getConversation.topics.topics.forEach((z) => {
                z.messageIds.forEach((a) => {
                    newtopicset.push({ name: z.text, id: a });
                });
            });
        } catch (error) {
            console.log("No topic", error)
        }
        setTopicSet(newtopicset);
        setConversation(conversation.data.getConversation);
        setConversationFile(conversation.data.getConversation.name);
    }

    const fetchAlerts = async () => {
        // try {
        //     const data = await getAlertsAPI({
        //         limit: 50,
        //         conversationId: conversationId,
        //     })
        //     setAlerts(data.items);
        // } catch (error) {
        //     console.log("fetch alerts error => ", error);
        //     return [];
        // }
    };

    React.useEffect(() => {
        const getConversationHelper = async () => {
            await fetchAlerts();
            await getConversationData();
        }
        getConversationHelper();
    }, [conversationId]);

    const [playicon, setPlayicon] = useState(true);
    const [waveformd, setWaveformd] = useState([]);
    const [canvswidth, setCanvswidth] = useState(1000);
    const [tagsMode, setTagsMode] = useState("trackers");
    const [progressWidth, setProgressWitdh] = useState(0);
    const inputEl = useRef(null);
    const canvref = useRef(null);
    const dref = useRef(null);

    const [audioURL, setAudioURL] = useState(null);
    const mouse = useMouse(canvref, {
        enterDelay: 100,
        leaveDelay: 100,
    });

    useEffect(() => {
        setCanvswidth(canvref.current.clientWidth);
    }, [canvref]);

    const getFileFromS3 = async () => {
        try {
            let file = null;
            if (conversation.s3Key) {
                console.log("Using SFTP bucket", conversation.s3Key);
                file = await Storage.get(conversation.s3Key, {
                    download: false,
                    region: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET_REGION,
                    level: 'public', // or 'protected', 'private'
                    bucket: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET_SFTP,
                    customPrefix: {
                        public: '', // remove 'public/' prefix
                    }
                });
            } else {
                file = await Storage.get(conversationFile, {
                    download: false,
                    region: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET_REGION,
                    level: 'public', // or 'protected', 'private'
                    bucket: process.env.REACT_APP_AWS_USER_FILES_S3_BUCKET
                });
            }

            const fileResponse = await fetch(file);

            if (!fileResponse.ok) {
                throw new Error(
                    `Failed to fetch file from S3. Status: ${fileResponse.status}`
                );
            }
            const blob = await fileResponse.blob();
            return blob;
        } catch (error) {
            console.error("Error fetching file from S3:", error);
            return null;
        }
    }

    async function makeWaveform(blob) {
        const audioContext = new AudioContext();
        const arrayBuffer = await blob.arrayBuffer();
        const options = {
            audio_context: audioContext,
            array_buffer: arrayBuffer,
            scale: 128,
        };
        return new Promise((resolve, reject) => {
            WaveformData.createFromAudio(options, (err, waveform) => {
                if (err) {
                    console.log({ err });
                    reject(err);
                } else {
                    // console.log({ waveform });
                    resolve(waveform);
                }
                audioContext.close();
            });
        });
    }

    function redraw(cuts, sens) {
        // console.log({sens});
        if (cuts === undefined) cuts = waveformd;
        const canvas = document.getElementById("canvas");
        const ctx = canvas.getContext("2d");
        let barwidth = parseInt(canvref.current.offsetWidth / cuts.length);
        let maxvol = Math.max(...cuts.map((z) => Math.abs(z)));
        // let minvol = Math.min(...cuts.map((z) => Math.abs(z)));
        cuts.forEach((z, zidx) => {
            let scaledy = parseInt((z / maxvol) * 75);
            // console.log(scaledy)
            if (sens[zidx].sen < -0.3) ctx.fillStyle = colours.orange100;
            else if (sens[zidx].sen > 0.3) ctx.fillStyle = colours.green100;
            else ctx.fillStyle = colours.dividergray;
            // if (z > 0) {
            //   if (zidx > 200 && zidx < 250) ctx.fillStyle = colours.dividergray;
            //   else ctx.fillStyle = colours.orange100;
            if (sens[zidx].sp === "Speaker 1") {
                // console.log("s1")
                // console.log(zidx * (barwidth + 1), 75 - Math.abs(scaledy), barwidth, Math.abs(scaledy))
                ctx.fillRect(
                    zidx * (barwidth + 1),
                    75 - Math.abs(scaledy),
                    barwidth,
                    Math.abs(scaledy)
                );
            } else {
                // console.log("s2")
                // console.log(zidx * (barwidth + 1), 75, barwidth,Math.abs(scaledy))
                ctx.fillRect(zidx * (barwidth + 1), 75, barwidth, Math.abs(scaledy));
            }
            // } else {
            //   if (zidx > 50 && zidx < 100) ctx.fillStyle = colours.dividergray;
            //   else ctx.fillStyle = colours.green100;
            // }
        });
    }

    async function getFunction() {
        const canvas = document.getElementById("canvas");
        canvas.width = canvref.current.clientWidth;        
        const blob = await getFileFromS3();
        if(blob === null) {
            return null;
        }
        const blobUrl = URL.createObjectURL(blob);
        setAudioURL(blobUrl);

        const waveform = await makeWaveform(blob);

        let original = waveform.toJSON().data;
        
        let newsample = [];
        const cuts = original.length / 200;
        
        while (original.length > cuts) {
            let samp = original.splice(0, cuts);
            let sign = newsample.length % 30 < 10 ? 1 : -1;
            newsample.push(sign * Math.max(...samp));
        }
        if (original.length > 0) newsample.push(Math.max(...original));

        WaveformData.create(waveform.toJSON());

        setWaveformd(newsample);
        if (conversation.transcript.messages) {
            let sent = conversation.transcript.messages.map((z) => {
                return {
                    t: (z.endTime) - (z.startTime),
                    sen: z.sentiment ? z.sentiment.polarity.score : 0,
                    sp: z.from.name,
                };
            });
            let totaltstime = sent.reduce((a, b) => (a = a + b.t), 0);
            let tscuttime = totaltstime / 200;
            let cutter = [];
            while (sent.length > 0) {
                if (sent[0].t > tscuttime) {
                    cutter.push({ t: tscuttime, sen: sent[0].sen, sp: sent[0].sp });
                    sent[0].t -= tscuttime;
                } else {
                    sent[1].t += sent[0].t;
                    sent[1].sen = (sent[1].sen + sent[0].sen) / 2;
                    sent.shift();
                }
                if (sent.length === 1) {
                    cutter.push({ t: tscuttime, sen: sent[0].sen, sp: sent[0].sp });
                    sent.shift();
                }
            }
            while (cutter.length < newsample.length)
                cutter.push({ t: tscuttime, sen: 0 });
            while (cutter.length > newsample.length) cutter.pop();
            redraw(newsample, cutter);
        }
    }

    useEffect(() => {
        if (conversationFile) {
            getFunction();
        }
    }, [conversationFile, size, conversation]);

    return (
        <Grid
            ref={scrollContainer}
            className="vocalysed-home-upadted transcript"
            container
            spacing={0}
            direction="row"
            flexGrow={1}
            padding={3}
            gap={3}
            overflow="auto"
            alignItems="start"
            sx={{ overflowX: "hidden" }}
            onScroll={(e) => {
                setScrollPosition(e.target.scrollTop);
            }}
        >
            <Paper
                sx={{ display: "flex", flexDirection: "column", width: '100%', borderRadius: 2.5, boxSizing: "border-box" }}
            >
                <Stack direction="row" flexWrap="wrap" gap={1} justifyContent={{ xs: "center", md: "space-between" }} className="card-piece-updated" sx={{ padding: { xs: '8px 0', md: 3 } }}>
                    <ButtonGroup
                        variant="contained"
                        aria-label="outlined primary button group"
                        className="buttons-border-extend"
                        style={{ display: "inline-block" }}
                    >
                        <Button
                            style={toggleButtonStyle(tsfilter === "Full", colours, themeMode)}
                            onClick={() => setTsFilter("Full")}
                        >
                            Full
                            <Typography variant="body2" component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>
                                &nbsp;Transcript
                            </Typography>
                        </Button>

                        <Button
                            style={toggleButtonStyle(tsfilter === "Agent", colours, themeMode)}
                            onClick={() => setTsFilter("Agent")}
                        >
                            Agent
                            <Typography variant="body2" component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>
                                &nbsp;Transcript
                            </Typography>
                        </Button>

                        <Button
                            style={toggleButtonStyle(tsfilter === "Client", colours, themeMode)}
                            onClick={() => setTsFilter("Client")}
                        >
                            Client
                            <Typography variant="body2" component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>
                                &nbsp;Transcript
                            </Typography>
                        </Button>
                    </ButtonGroup>
                    <LegendItemGroup
                        circleSize={themeMode === THEME_MODES.COLOR_VISION ? 24 : 16}
                        items={[
                            { label: "Neutral", color: colours.dividergray },
                            { label: "Negative", color: colours.critical100, pattern: themeMode === THEME_MODES.COLOR_VISION && CustomSvgIcons.negativePattern },
                            { label: "Positive", color: colours.success100, pattern: themeMode === THEME_MODES.COLOR_VISION && CustomSvgIcons.positivePattern },
                        ]}
                    />

                    {true ? null : (
                        <TextField
                            id="input-with-icon-textfield"
                            label="Search"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <FeatherIcon
                                            icon="search"
                                            style={{ color: colours.black }}
                                        />
                                    </InputAdornment>
                                ),
                            }}
                            variant="standard"
                        />
                    )}
                </Stack>
                <Stack direction="row" alignItems="center" className="card-piece-updated" sx={{ px: { xs: 1, md: 3 }, pb: { xs: 1, md: 3 } }}>
                    <div
                        style={{
                            width: "5%",
                            margin: "auto",
                            textAlign: "end",
                            marginRight: "15px",
                            minWidth: "fit-content",
                        }}
                    >
                        <ReactPlayer
                            url={audioURL}
                            playing={!playicon}
                            ref={inputEl}
                            width="0px"
                            onProgress={(e) => {
                                setProgressWitdh(e.played);
                                // console.log(e.playedSeconds)
                                if (autoscroll && e.playedSeconds > 10) {
                                    const message = conversation.transcript.messages
                                        .find((z) => z.startTime <= e.playedSeconds && e.playedSeconds <= z.endTime);
                                    if (!message) {
                                        return;
                                    }
                                    const place = document.getElementById(message.id);
                                    if (place) {
                                        if ("scrollBehavior" in document.documentElement.style) {
                                            place.scrollIntoView({
                                                behavior: "smooth",
                                                block: "center",
                                                inline: "nearest"
                                            });
                                        } else {
                                            // Fallback for older browsers like IE11
                                            scrollContainer.current.scrollTo({
                                                top: (place.offsetTop - 300),
                                                behavior: "smooth",
                                            });
                                        }
                                    }
                                }
                            }}
                            height="0px"
                        />
                        <CustomTooltip title={playicon ? "Play" : "Pause"}>
                            <IconButton
                                onClick={() => setPlayicon(!playicon)}
                                aria-label={playicon ? "Play" : "Pause"}
                                color="primary"
                                size="small"
                            >
                                <FeatherIcon
                                    size="48"
                                    icon={playicon ? "play-circle" : "pause-circle"}
                                    style={{
                                        ...colours.shadowMd,
                                        strokeWidth: 1,
                                        borderRadius: "50%",
                                    }}
                                />
                            </IconButton>
                        </CustomTooltip>
                    </div>
                    <Stack
                        direction="row"
                        alignItems="center"
                        sx={{
                            minWidth: '1px',
                            width: "95%",
                            height: { xs: "100px", lg: "170px" },
                            borderRadius: { xs: "12px", lg: "20px" },
                            position: 'relative',
                            overflow: "hidden",
                            boxShadow:
                                `inset 4px 4px 5px ${alpha(constColours.black, .15)}, inset -4px -4px 5px ${alpha(constColours.black, .15)}`,
                        }}
                        ref={canvref}
                        onClick={() => {
                            let pos = mouse.x / mouse.elementWidth;
                            setPlayicon(false);
                            inputEl.current.seekTo(pos);
                        }}
                    >
                        <canvas
                            id="canvas"
                            width={canvswidth}
                            height={150}
                            ref={dref}
                            style={{
                                padding: "9px 0",
                                position: "absolute",
                                top: 0,
                                left: 0,
                                height: "100%",
                                width: "100%",
                            }}
                        />
                        <div
                            style={{
                                position: "absolute",
                                width: canvswidth * progressWidth,
                                height: '100%',
                                background: alpha(colours.black, .25),
                                top: 0,
                                left: 0,
                            }}
                        />
                    </Stack>
                </Stack>
                <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent={{ xs: "center", sm: "space-between" }}
                    flexWrap="wrap"
                    sx={(theme) => ({
                        background: theme.palette.mode === THEME_MODES.LIGHT ? colours.basegray : colours.white,
                        position: "sticky",
                        top: -25,
                        left: 0,
                        zIndex: 2,
                        px: { xs: 1, md: 2.5 },
                        py: 1,
                        boxShadow: scrollPosition > 300 ? `0px 2px 4px ${alpha(constColours.black, .1)}` : 'none',
                    })}
                >
                    <Stack direction="row" alignItems="center">
                        {scrollPosition > 300 && (
                            <CustomTooltip title={playicon ? "Play" : "Pause"}>
                                <IconButton
                                    onClick={() => setPlayicon(!playicon)}
                                    aria-label={playicon ? "Play" : "Pause"}
                                    color="primary"
                                    size="small"
                                >
                                    <FeatherIcon
                                        size="48"
                                        icon={playicon ? "play-circle" : "pause-circle"}
                                        style={{
                                            ...colours.shadowMd,
                                            strokeWidth: 1,
                                            borderRadius: "50%",
                                        }}
                                    />
                                </IconButton>
                            </CustomTooltip>
                        )}
                        <Switch
                            inputProps={{ 'aria-label': autoscroll ? "Auto Scroll On" : "Auto Scroll Off" }}
                            color="primary"
                            value={autoscroll}
                            onChange={(c) => {
                                setAutoscroll(c.target.checked);
                            }}
                        />
                        Auto Scroll
                    </Stack>
                    <ButtonGroup
                        variant="contained"
                        aria-label="outlined primary button group"
                        className="buttons-border-extend"
                    >
                        <Button
                            onClick={() => setTagsMode("trackers")}
                            style={toggleButtonStyle(tagsMode === "trackers", colours, themeMode)}
                        >
                            Insight
                        </Button>

                        <Button
                            onClick={() => setTagsMode("alerts")}
                            style={toggleButtonStyle(tagsMode === "alerts", colours, themeMode)}
                        >
                            Alerts
                        </Button>

                        <Button
                            onClick={() => setTagsMode("topics")}
                            style={toggleButtonStyle(tagsMode === "topics", colours, themeMode)}
                        >
                            Topics
                        </Button>

                    </ButtonGroup>
                </Box>
                <Stack sx={{ padding: { xs: 1, md: 2.5 } }}>
                    {!conversation.transcript
                        ? null
                        : conversation.transcript.messages
                            // .filter((z) => {
                            //   // z.from.name === agent;
                            //   if (tsfilter === "Full") return true;
                            //   else {
                            //     if (
                            //       tsfilter === "Agent" &&
                            //       z.from.name.toUpperCase() === agent.toUpperCase()
                            //     )
                            //       return true;
                            //     else return false;
                            //   }
                            // })
                            .map((z, zidx) => (
                                <MessageRow
                                    key={zidx}
                                    id={z.id}
                                    tagsMode={tagsMode}
                                    filter={tsfilter}
                                    input={{
                                        id: z.id,
                                        text: z.text,
                                        phrases: JSON.stringify(z.phrases),
                                        type: z.from.name === agent ? "agent" : "client",
                                        comment: z.comment,
                                        bm: z.bm,
                                        alerts: trackerSet, //["empathy", "agent empathy"],
                                        trackers: trackerSet,
                                        topics: topicSet,
                                    }}
                                    output={async (c) => {
                                        // console.log({ c });
                                        Utils.sendProgressBar(true);
                                        if (c.func === "settext") {
                                            let tscr = Object.assign(
                                                {},
                                                conversation.transcript
                                            );
                                            let found = tscr.messages.find(
                                                (a) => a.id === c.message
                                            );
                                            if (found) found.text = c.newtext;
                                            await Utils.genericMutation(
                                                "updateConversation",
                                                {
                                                    id: conversation.id,
                                                    transcript: JSON.stringify(tscr),
                                                }
                                            );
                                        }
                                        if (c.func === "setcomment") {
                                            let tscr = Object.assign(
                                                {},
                                                conversation.transcript
                                            );
                                            let found = tscr.messages.find(
                                                (a) => a.id === c.message
                                            );
                                            if (found) found.comment = c.newtext;
                                            await Utils.genericMutation(
                                                "updateConversation",
                                                {
                                                    id: conversation.id,
                                                    transcript: JSON.stringify(tscr),
                                                }
                                            );
                                        }
                                        if (c.func === "setbm") {
                                            let tscr = Object.assign(
                                                {},
                                                conversation.transcript
                                            );
                                            let found = tscr.messages.find(
                                                (a) => a.id === c.message
                                            );
                                            if (found) found.bm = c.bm;
                                            let allbms = conversation.bookmarks;
                                            if (allbms === null) allbms = [];
                                            else allbms = allbms.split(",");
                                            allbms = allbms.concat(c.bm);
                                            allbms = [...new Set(allbms)];
                                            allbms = allbms.join(",");

                                            const { data } = await Utils.genericMutation(
                                                "updateConversation",
                                                {
                                                    id: conversation.id,
                                                    transcript: JSON.stringify(tscr),
                                                    bookmarks: allbms,
                                                }
                                            );
                                            if (data?.updateConversation) {
                                                const bookmarks = data.updateConversation.bookmarks || null;
                                                console.log("bookmarks ", bookmarks)
                                                setConversation({ ...conversation, bookmarks })
                                            }
                                        }
                                        Utils.sendSnackBar(null);
                                    }}
                                />
                            ))}
                </Stack>
            </Paper>
        </Grid>
    );
}

export default ConversationTranscript;